import styled from 'styled-components';

const Container = styled.div``;

const FilterWrapper = styled.div`
  padding: 0 15px 15px;
  display: flex;
  grid-gap: 40px;
  align-items: center;
  justify-content: flex-end;
`;

const PaginationWrapper = styled.div`
  margin: 30px 0;
  display: flex;
  justify-content: flex-end;
`;

export { Container, FilterWrapper, PaginationWrapper };
